import { useEffect, useRef, useState } from "react";
import { STOP_CATEGORIES } from "../data/stopCategories.js";
import { limitarRespostaStop } from "../domain/stop.js";

export function useStopAnswers({ active, initialAnswers = {}, resetKey }) {
  const [answers, setAnswers] = useState(initialAnswers);
  const [activeIndex, setActiveIndex] = useState(0);
  const answersRef = useRef(initialAnswers);

  useEffect(() => {
    const next = initialAnswers || {};
    answersRef.current = next;
    setAnswers(next);
    setActiveIndex(0);
  }, [resetKey]);

  const replaceAnswer = (categoryId, value) => {
    setAnswers((current) => {
      const next = {
        ...current,
        [categoryId]: limitarRespostaStop(value),
      };
      answersRef.current = next;
      return next;
    });
  };

  const typeKey = (key) => {
    if (!active) return;
    const categoryId = STOP_CATEGORIES[activeIndex].id;
    const current = answersRef.current[categoryId] || "";
    if (key === "ENTER") {
      setActiveIndex((index) => (index + 1) % STOP_CATEGORIES.length);
    } else if (key === "BACKSPACE") {
      replaceAnswer(categoryId, current.slice(0, -1));
    } else if (key === "SPACE") {
      if (current && !current.endsWith(" ")) {
        replaceAnswer(categoryId, `${current} `);
      }
    } else {
      replaceAnswer(categoryId, current + key);
    }
  };

  useEffect(() => {
    const handleKey = (event) => {
      if (!active) return;
      if (event.key === "Backspace") {
        event.preventDefault();
        typeKey("BACKSPACE");
      } else if (event.key === "Enter") {
        event.preventDefault();
        typeKey("ENTER");
      } else if (event.key === " ") {
        event.preventDefault();
        typeKey("SPACE");
      } else if (/^[a-zA-ZÀ-ÿ]$/.test(event.key)) {
        typeKey(event.key.toUpperCase());
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [active, activeIndex]);

  return {
    answers,
    answersRef,
    activeIndex,
    setActiveIndex,
    typeKey,
  };
}
